import { render } from "./Home.vue?vue&type=template&id=39f835a4"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=39f835a4&lang=scss"
script.render = render

export default script